var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconHeadphones = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.58 12.2257C17.58 11.2817 18.28 10.5019 19.16 10.3993V9.12687C19.16 5.52334 16 2.31185 12.25 2.31185C12.0845 2.31185 12.4182 2.29291 12.25 2.29291C8 2.29291 4.86 5.35075 4.86 9.12687V10.3993C5.76 10.5019 6.44 11.2817 6.44 12.2257V15.2631C6.44 16.2892 5.64 17.1101 4.64 17.1101H3.8C2.8 17.1101 2 16.2892 2 15.2631V12.2257C2 11.2817 2.7 10.5019 3.58 10.3993V9.12687C3.58 4.63246 7 1 12.25 1C12.418 1 12.0847 1.00534 12.25 1.01587C17 1.01587 20.42 4.8048 20.42 9.12687V10.3993C21.32 10.5019 22 11.2817 22 12.2257V15.2631C22 16.2892 21.2 17.1101 20.2 17.1101H19.36C18.36 17.1101 17.56 16.2892 17.56 15.2631V12.2257H17.58ZM10.12 21.1735C10.12 20.5373 10.62 20.0243 11.24 20.0243H13.48C13.94 20.0243 14.34 20.3116 14.5 20.722C16.14 20.209 17.5 19.0597 18.32 17.5616C18.64 17.7257 19 17.8078 19.38 17.8078H19.62C18.62 19.8806 16.78 21.4608 14.56 22.0765C14.46 22.6101 14 23 13.46 23H11.24C10.62 23 10.12 22.4869 10.12 21.8507V21.1735Z",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconHeadphones);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-headphones.4577de9741e7895315785bfcad1bd4a1.svg";